import { ComingSoonPanel, IconFlag } from '@shared/ui';

/**
 * Which components this museum has, and what turned them on.
 *
 * The client-side half of the catalog's Components tab. Empty until the catalog
 * defines what a component is — building it first would mean inventing the
 * things it is supposed to list.
 *
 * When it lands it is a list of buttons, not switches. Activating a component
 * is a chargeable act that can answer `pending`, and a switch promises
 * immediacy and symmetric reversibility that a charge does not have.
 */
export function ClientComponentsTab() {
    return (
        <ComingSoonPanel
            icon={<IconFlag className="size-6" />}
            title="Components"
            blurb="One row per component this museum has, what granted it, and what activating or removing one does to the flags underneath. It lands with the catalog it reads."
        />
    );
}
